module.exports = __webpack_public_path__ + "static/media/M.5f455028.jpg";